var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.5,
    width: 78,
    height: 78,
    rx: 39,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.495 34.2982C52.495 40.1852 50.0294 45.774 45.1829 49.3076C39.172 53.6896 30.5546 53.8587 24.25 49.9827C27.4846 50.6146 31.2289 49.3362 33.8051 47.42C32.4672 47.4188 31.1627 47.0039 30.0717 46.2326C28.9808 45.4613 28.1573 44.3717 27.715 43.1144C28.6622 43.3455 29.7152 43.1954 30.655 43.0119C27.6917 42.4952 25.4903 39.849 25.51 36.8611C26.3974 37.3943 27.4136 37.6777 28.45 37.6811C26.7696 36.656 25.615 34.7082 25.615 32.5555C25.6196 31.4748 25.9093 30.4143 26.4551 29.4802C29.6048 33.1706 34.4349 35.6309 39.79 35.9385C38.9701 31.9381 41.9231 28.25 46.09 28.25C47.98 28.25 49.66 28.9675 50.8151 30.1977C52.285 29.8902 54.91 28.66 54.91 28.66C54.385 30.1977 53.3349 31.3253 52.075 32.1455C53.3349 31.9405 54.595 31.6334 55.75 31.1203C54.8251 32.3309 53.7287 33.4013 52.495 34.2982Z",
    fill: "#D1337F"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.5,
    width: 78,
    height: 78,
    rx: 39,
    stroke: "#D1337F",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.0b2acd580c160b77d327da4c5bbe45f0.svg";
export { ForwardRef as ReactComponent };